import { connect } from 'react-redux';
// import { fromJS } from 'immutable';

const withTrip = connect(
  state => {
    // const forcedMapData = state.trip.data.toJS ? state.trip.data.toJS() : (fromJS(state.trip.data)).toJS();
    return {
      trip: state.trip.data,
    };
  }
);

export default withTrip;
